import * as React from 'react';
const SvgWatchSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M3.293 4.707a1 1 0 0 1 1.414-1.414l16 16a1 1 0 0 1-1.414 1.414zM4 12c0-1.065.615-2.365 1.65-3.52L7.07 9.9C6.39 10.678 6 11.478 6 12c0 1.26 2.66 4.47 6 4.47a5.5 5.5 0 0 0 1.444-.197l1.587 1.586c-.94.4-1.965.641-3.031.641-4.34 0-8-3.93-8-6.5M8.954 6.125l1.59 1.59A5.8 5.8 0 0 1 12 7.53c3.47 0 6 3.14 6 4.47 0 .493-.408 1.286-1.105 2.067l1.43 1.429C19.37 14.336 20 13.041 20 12c0-2.51-3.58-6.5-8-6.5a7.9 7.9 0 0 0-3.046.625"
    />
    <path
      fill="currentColor"
      d="M9 12q0-.084.005-.167l3.162 3.162Q12.084 15 12 15c-1.65 0-3-1.35-3-3M11.833 9.005l3.162 3.162Q15 12.084 15 12a3 3 0 0 0-3.167-2.995"
    />
  </svg>
);
export default SvgWatchSlash;
